/* eslint-disable i18next/no-literal-string -- TanStack cache key segments */
import type { AssetVariant } from '../model/types';

export const ASSET_QUERY_KEYS = {
  all: ['assets'] as const,

  /**
   * Keyed by the sorted id list and the variant, so two callers asking for the
   * same set share one entry regardless of the order they listed them in, and
   * a thumbnail request never collides with an original (or another variant)
   * for the same ids.
   */
  urls: (assetIds: readonly string[], variant?: AssetVariant) =>
    [...ASSET_QUERY_KEYS.all, 'urls', [...assetIds].sort(), variant] as const,
} as const;
